module.exports = __webpack_public_path__ + "static/media/hero-background.727bcfa1.jpg";